import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Form, Select, InputNumber, Input, Row, Col } from 'antd'
var placeholderFields = require('./placeholderFields')

var PLACEHOLDER_CATEGORIES = placeholderFields.PLACEHOLDER_CATEGORIES
var PLACEHOLDER_FIELDS = placeholderFields.PLACEHOLDER_FIELDS

var Option = Select.Option
var OptGroup = Select.OptGroup

export default class PlaceholderDialog extends React.PureComponent {

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    placeholder: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    var ph = props.placeholder || {}
    this.state = {
      field: ph.field || '',
      font_size: ph.font_size || 10,
      font_color: ph.font_color || '#000000',
      align: ph.align || 'left',
      width: ph.width || 50,
      height: ph.height || 10,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      var ph = this.props.placeholder || {}
      this.setState({
        field: ph.field || '',
        font_size: ph.font_size || 10,
        font_color: ph.font_color || '#000000',
        align: ph.align || 'left',
        width: ph.width || 50,
        height: ph.height || 10,
      })
    }
  }

  handleFieldChange = (value) => {
    var fieldDef = null
    for (var i = 0; i < PLACEHOLDER_FIELDS.length; i++) {
      if (PLACEHOLDER_FIELDS[i].value === value) {
        fieldDef = PLACEHOLDER_FIELDS[i]
        break
      }
    }
    var updates = { field: value }
    if (fieldDef && fieldDef.type === 'image') {
      updates.width = 40
      updates.height = 20
    } else if (fieldDef && fieldDef.type === 'list') {
      updates.width = 60
      updates.height = 40
      updates.font_size = 8
    }
    this.setState(updates)
  }

  handleSave = () => {
    if (!this.state.field) return

    var fieldDef = null
    for (var i = 0; i < PLACEHOLDER_FIELDS.length; i++) {
      if (PLACEHOLDER_FIELDS[i].value === this.state.field) {
        fieldDef = PLACEHOLDER_FIELDS[i]
        break
      }
    }

    this.props.onSave({
      field: this.state.field,
      type: fieldDef ? fieldDef.type : 'text',
      category: fieldDef ? fieldDef.category : 'project',
      font_size: this.state.font_size,
      font_color: this.state.font_color,
      align: this.state.align,
      width: this.state.width,
      height: this.state.height,
    })
  }

  render() {
    var { visible, onCancel } = this.props
    var state = this.state

    var selectedField = null
    for (var i = 0; i < PLACEHOLDER_FIELDS.length; i++) {
      if (PLACEHOLDER_FIELDS[i].value === state.field) {
        selectedField = PLACEHOLDER_FIELDS[i]
        break
      }
    }
    var isImage = selectedField && selectedField.type === 'image'

    return (
      <Modal
        title="Configure Field"
        visible={visible}
        onOk={this.handleSave}
        onCancel={onCancel}
        okText="Save"
        okButtonProps={{ disabled: !state.field }}
        width={480}
      >
        <Form layout="vertical" size="small">
          <Form.Item label="Field">
            <Select
              value={state.field || undefined}
              onChange={this.handleFieldChange}
              placeholder="Select a field..."
              showSearch
              optionFilterProp="children"
              style={{ width: '100%' }}
            >
              {PLACEHOLDER_CATEGORIES.map(function(cat) {
                var fields = PLACEHOLDER_FIELDS.filter(function(f) { return f.category === cat.key })
                return (
                  <OptGroup key={cat.key} label={cat.label}>
                    {fields.map(function(f) {
                      return <Option key={f.value} value={f.value}>{f.label}</Option>
                    })}
                  </OptGroup>
                )
              })}
            </Select>
          </Form.Item>

          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="Width (mm)">
                <InputNumber
                  min={5}
                  max={300}
                  value={state.width}
                  onChange={function(v) { this.setState({ width: v }) }.bind(this)}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Height (mm)">
                <InputNumber
                  min={3}
                  max={200}
                  value={state.height}
                  onChange={function(v) { this.setState({ height: v }) }.bind(this)}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>

          {!isImage && (
            <Row gutter={12}>
              <Col span={8}>
                <Form.Item label="Font Size">
                  <InputNumber
                    min={6}
                    max={48}
                    value={state.font_size}
                    onChange={function(v) { this.setState({ font_size: v }) }.bind(this)}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Colour">
                  <Input
                    type="color"
                    value={state.font_color}
                    onChange={function(e) { this.setState({ font_color: e.target.value }) }.bind(this)}
                    style={{ width: '100%', padding: 2 }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Alignment">
                  <Select
                    value={state.align}
                    onChange={function(v) { this.setState({ align: v }) }.bind(this)}
                    style={{ width: '100%' }}
                  >
                    <Option value="left">Left</Option>
                    <Option value="center">Centre</Option>
                    <Option value="right">Right</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </Modal>
    )
  }
}
